import { EVENTS } from '@lumapps/events/keys';
import { GLOBAL } from '@lumapps/translations';

import { EVENT_PICKER_FILTER_TYPES, SortField } from './types';

export const SORT_FIELDS: SortField[] = [
    { label: GLOBAL.SORT_NEWEST, id: 'desc' },
    { label: GLOBAL.SORT_OLDEST, id: 'asc' },
];

export const TEMPORALITY_FILTERS = [
    { id: EVENT_PICKER_FILTER_TYPES.TEMPORALITY_PAST, value: [EVENTS.TEMPORALITY_PAST] },
    { id: EVENT_PICKER_FILTER_TYPES.TEMPORALITY_ONGOING, value: [EVENTS.TEMPORALITY_ONGOING] },
    { id: EVENT_PICKER_FILTER_TYPES.TEMPORALITY_ALL, value: [GLOBAL.ALL_TIME] },
    { id: EVENT_PICKER_FILTER_TYPES.TEMPORALITY_FUTURE, value: [EVENTS.TEMPORALITY_FUTURE] },
];

export const DEFAULT_FILTERS = [
    { id: EVENT_PICKER_FILTER_TYPES.TEMPORALITY_ALL, value: [GLOBAL.ALL_TIME] },
    {
        id: EVENT_PICKER_FILTER_TYPES.COMMUNITIES,
        value: ['All'],
    },
];
